import startApp from "../../../entry.js";
import articlePage from "./article.vue";

startApp(articlePage);